<ng-template #addressModal let-modal>
  <div class="modal-content">
    <div class="modal-header border-bottom">
      <h4 class="modal-title">
        {{ "label-title.add" | translate | titlecase }}
        {{ "label-title.address" | translate | titlecase }}
      </h4>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body center-model-body-height">
      <form [formGroup]="addressForm">
        <div class="row">
          <div class="col-12 mb-3">
            <div class="search-address autocomplete-container">
              <label for="autocomplete-address" class="col-form-label pt-0">
                {{ "label-title.address" | translate | titlecase }}
              </label>
              <input
                type="text"
                name="city"
                id="autocomplete-address"
                class="form-control"
                formControlName="placeAddress"
                placeholder="{{ 'label-title.search-address' | translate }}"
                autocomplete="off"
                (input)="onInputChange($event)"
              />
              @if(predictions.length > 0) {
              <ul class="autocomplete-dropdown">
                @for (prediction of this.predictions; track $index) {
                <li [class.selected]="isSelected($index)">
                  <a href="javascript:void(0);" class="text-ellipsis" (click)="onPredictionSelect(prediction)">
                    {{ prediction.description }}
                  </a>
                </li>
                }
                <img src="../../../../assets/images/default-images/google_images/google_on_white.png" alt="Google Logo" class="p-2" />
              </ul>
              } @if (addressInput?.invalid && addressInput?.touched) {
              <div class="invalid-message">
                @if (addressInput?.hasError('required')) {
                <p class="m-0">{{ "label-title.address" | translate | titlecase }} {{ "label-title.is-required" | translate }}</p>
                }
              </div>
              }
            </div>
          </div>

          <div class="col-12">
            <div id="address-map"></div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" id="saveAddress" (click)="onSaveAddress()">
          {{ "button-title.save" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
